<script setup lang="ts">
interface CollabsAndCommunity {
  id: number
  name: string
  image: string
}

defineProps<{
  data: CollabsAndCommunity[]
  reverse?: boolean
}>()
</script>

<template>
  <UCarousel
    v-slot="{ item }"
    loop
    :auto-scroll="{
      speed: 1,
      stopOnInteraction: false,
      stopOnMouseEnter: false,
      direction: reverse ? 'backward' : 'forward',
    }"
    :items="data"
    :ui="{ item: 'basis-25' }"
  >
    <div class="flex flex-col items-center gap-2">
      <NuxtImg
        loading="lazy"
        :src="item.image"
        class="object-contain w-15 h-15"
        :alt="item.name"
      />
      <p
        class="text-sm tracking-wide text-[#969696] text-center leading-4.25 break-words"
      >
        {{ item.name }}
      </p>
    </div>
  </UCarousel>
</template>
